module.exports = __webpack_public_path__ + "static/media/1.dca147d6.jpg";